import { QueueStore } from '../store/queue-store';

export class QueueRegistry {
    private queueStores: Set<QueueStore> = new Set<QueueStore>();
    public addQueueStore(queueStore: QueueStore): void {
        this.queueStores.add(queueStore);
    }
    public removeQueueStore(queueStore: QueueStore): void {
        this.queueStores.delete(queueStore);
    }
    public getUnitQueueStores(): QueueStore[] {
        const unitQueueStores: QueueStore[] = [];
        for (const queueStore of this.queueStores.values()) {
            if (queueStore.workspacePanel.queue.dataEntityType === 'UNIT') {
                unitQueueStores.push(queueStore);
            }
        }
        return unitQueueStores;
    }
}
